// extracted by mini-css-extract-plugin
export default {"card-editor":"card-editor_card-editor__zNFwN","card-slide":"card-editor_card-slide__hnQbb"};